import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 13px;
`;

export const QuantityValue = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: bold;
  font-size: 12px;
  line-height: 19px;
  color: #0B29FB;
`;

export const QuantityText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  line-height: 19px;
  color: rgba(122, 122, 122, 0.87);
`;
